module.exports = __webpack_public_path__ + "img/DSC_7379-2.63a463ea.jpeg";